import { Pipe, PipeTransform } from '@angular/core';
import { AddressFormData } from './address-form-data';

@Pipe({
  name: 'addressErrors',
  standalone: true,
})
export class AddressErrorsPipe implements PipeTransform {
  private errorRecord: Record<keyof AddressFormData, string> = {
    administrative_area_level_2: 'Provincia',
    country: 'Stato',
    administrative_area_level_3: 'Città',
    postal_code: 'Cap',
    route: 'Indirizzo',
    street_number: 'Numero civico',
  };

  transform(value: keyof AddressFormData, ...args: unknown[]): unknown {
    return this.errorRecord[value] || '';
  }
}
